import React from 'react'
import { Route, Routes } from 'react-router-dom'
import User from "../layout/user/User";
import AddUser from "../layout/user/AddUser";

function UserPage() {
    return (
        <>
            <Routes>
                <Route path="/" element={<User />} />
                <Route path="/add" element={<AddUser />} />
                <Route path="/update/:id" element={<AddUser />} />
            </Routes>
        </>
    )
}

export default UserPage;
